import "app/App.css";
import { useState } from "react";

import MenuBar from "shared/components/layout/menubar";
import { Link } from "react-router-dom";
import { Layout } from "antd";
import Sider from "antd/es/layout/Sider";
import { Content, Header } from "antd/es/layout/layout";

import rubberneck_logo from "shared/assets/images/logos/rubberneck-logo-trans.png";
import rubberneck_logo_mini from "shared/assets/images/logos/rubberneck-logo-mini-trans.png";
import LanguageSwitcher from "../ui/LanguageSwitcher";
import OrgSwitcher from "../ui/OrgSwitcher";
import { useUserOrg } from "shared/contexts/UserOrgContext";
import { servicesUrlConfig } from "shared/config/setting";

function Main({ children }) {
  const { selectedOrg } = useUserOrg();
  const getStaticUrl = servicesUrlConfig.ROBOTS_API.getStaticUrl;

  const orgLogoSrc = selectedOrg?.organization?.logo_path
    ? getStaticUrl(selectedOrg.organization.logo_path)
    : rubberneck_logo;
  const orgLogoCompactSrc = selectedOrg?.organization?.logo_compact_path
    ? getStaticUrl(selectedOrg.organization.logo_compact_path)
    : rubberneck_logo_mini;

  const searchParams = new URLSearchParams(window.location.search);
  const qsHideMenuBar =
    searchParams.has("hide-menu-bar") &&
    searchParams.get("hide-menu-bar").trim().toLocaleLowerCase() == "true";

  const [collapsed, setCollapsed] = useState(false);

  const siderStyle = {
    overflow: "auto",
    height: "100vh",
    position: "sticky",
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: "thin",
    scrollbarGutter: "stable",
  };

  const zeroWidthTriggerStyle = {
    top: 35,
    right: collapsed ? -15 : 0,
    width: 24,
    height: 24,
    // borderRadius: "50%",
    transition: "all 0.3s",
    // background: "#001529",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    cursor: "pointer",
  };

  return (
    <div>
      <Layout>
        {!qsHideMenuBar && (
          <Sider
            style={siderStyle}
            theme="dark"
            // trigger={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            // zeroWidthTriggerStyle={zeroWidthTriggerStyle}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            breakpoint="lg"
            // collapsedWidth="0"
          >
            <div
              className="logo"
              style={{
                height: 70,
                margin: 8,
                background: "rgba(255, 255, 255, 0.95)",
              }}
            >
              {!collapsed && (
                <Link to="/dashboard">
                  <img
                    src={orgLogoSrc}
                    alt="Organization Logo"
                    style={{
                      height: "100%",
                      width: "100%",
                      // margin: 6,
                      verticalAlign: "middle",
                      // borderRadius: "50%",
                    }}
                  />
                </Link>
              )}
              {collapsed && (
                <Link to="/dashboard">
                  <img
                    src={orgLogoCompactSrc}
                    style={{
                      height: "100%",
                      width: "100%",
                      verticalAlign: "middle",
                    }}
                  />
                </Link>
              )}
            </div>
            <MenuBar />
                    
        {/* Bottom controls: Org Switcher + Language Switcher */}        
        <div style={{ 
          margin: '8px',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          background: 'inherit',
          width: '100%',
          position: 'absolute',
          bottom: 50,
          left: 0,
        }}>
          <OrgSwitcher collapsed={collapsed} />
          <LanguageSwitcher
            size="small"
            showLabel={!collapsed}
            iconOnly={collapsed}
            theme="dark"
            style={{
              width: '100%'
            }}
          />
        </div>          
          </Sider>
        )}

        <Layout>
          {/* <Header theme="dark">
            <NavBar />
          </Header> */}
          <Content>{children}</Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default Main;
